import Footer from '@app-ila/components/Footer/Footer';
import ILAHeader from '@app-ila/components/Header/Header';
import { Box, Spinner } from '@chakra-ui/react';
import { Suspense, useState } from 'react';
// import { useRouter } from 'next/navigation';
// import { useEffect } from 'react';

export default function ILALayout({ children }) {
  const [shPrograms, setShPrograms] = useState(false);
  // const router = useRouter();

  // useEffect(() => {
  //   router?.events?.on('routeChangeStart', (url, { shallow }) => {
  //     console.log(`routing to ${url}`, `is shallow routing: ${shallow}`);
  //   });

  //   router?.events?.on('routeChangeError', (err, url) => {
  //     console.log(url, err.cancelled ? 'you cancelled the navigation' : err);
  //   });

  //   router?.events?.on('routeChangeComplete', url => {
  //     console.log(`completely routed to ${url}`);
  //   });

  //   router?.events?.on('beforeHistoryChange', url => {
  //     console.log(`appending ${url} to history`);
  //   });

  //   router?.events?.on('hashChangeComplete', url => {
  //     console.log(`navigated to ${url}`);
  //   });
  // }, []);

  return (
    <Suspense fallback={<Spinner />}>
      <Box
        bgColor="#08084A"
        backgroundImage="url('https://static.sadhguru.org/d/46272/1692985330-artboard-ila.png')"
        backgroundRepeat="no-repeat"
        bgPos="top right"
      >
        {/* header section */}
        <ILAHeader showPrograms={shPrograms} setShowPrograms={setShPrograms} />

        {/* main content to render */}
        <Box display={shPrograms ? 'none' : 'block'}>{children}</Box>
        {/* Footer section */}
        {!shPrograms && <Footer />}
      </Box>
    </Suspense>
  );
}
